import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Input from "../../../component/inputpm";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { Select } from "@mui/material";
import { withTranslation } from "react-i18next";
import classes from "../component/component.module.css";
const SearchComponent = (props) => {
  const t = props.t;
  const customAttributesList = props.customAttributesList;
  const clearFilterTrigger = props.clearFilterTrigger;
  const valueTakenFromChild = props.valueTakenFromChild;

  const [formData, setFormData] = useState({}); // State to hold input values
  const [selectedValue, setSelectedValue] = useState("-");

  // Handle value changes
  // const handleChange = (e, attrName) => {
  //     const { value } = e.target;
  //     setFormData((prevData) => ({
  //         ...prevData,
  //         [attrName]: value
  //     }));
  // };

  const handleChange = (e, attrName) => {
    const { value } = e.target;
    setSelectedValue(e.target.value);
    setFormData((prevData) => {
      // Create a shallow copy of the previous data
      const updatedData = { ...prevData };
      if (value === "" || value === "-") {
        // Remove the attribute if the value is empty
        delete updatedData[attrName];
      } else {
        // Otherwise, update the attribute
        updatedData[attrName] = value;
      }
      return updatedData;
    });
  };

  const convertToQueryString = (obj) => {
    return Object.keys(obj)
      .map(
        (key) => `&${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`,
      )
      .join("");
  };

  useEffect(() => {
    valueTakenFromChild(convertToQueryString(formData));
  }, [formData, valueTakenFromChild]);

  useEffect(() => {
    setFormData({});
  }, [clearFilterTrigger]);

  // Handle search button click
  const handleSearch = () => {
    console.log("Search Payload:", formData);
    // Replace the console.log with your API call
    // fetch('api/search', { method: 'POST', body: JSON.stringify(formData) })
  };

  return (
    <>
      {customAttributesList
        .filter((field) => field.searchable) // Filter only searchable fields
        .map((field, index) => (
          // <div key={index} style={{ marginBottom: "10px" }}>
          //     <label style={{ display: "block" }}>
          //         {field.attrName}:
          //     </label>
          //     {field.valueType === "collection" ? (
          //         <select
          //             onChange={(e) => handleChange(e, field.attrName)}
          //             defaultValue=""
          //         >
          //             <option value="" disabled>
          //                 Select {field.attrName}
          //             </option>
          //             {field.options.map((option) => (
          //                 <option key={option.id} value={option.value}>
          //                     {option.value}
          //                 </option>
          //             ))}
          //         </select>
          //     ) : (
          //         <input
          //             type={
          //                 field.valueType === "number"
          //                     ? "number"
          //                     : field.valueType === "boolean"
          //                     ? "checkbox"
          //                     : "text"
          //             }
          //             defaultValue={
          //                 field.valueType === "boolean"
          //                     ? field.attrValue === "true"
          //                     : field.attrValue
          //             }
          //             onChange={(e) => handleChange(e, field.attrName)}
          //             checked={
          //                 field.valueType === "boolean"
          //                     ? field.attrValue === "true"
          //                     : undefined
          //             }
          //         />
          //     )}
          // </div>
          // <button type="button" onClick={handleSearch}>
          //     Search
          // </button>
          <Grid
            item
            key={index}
            size={{
              xs: 6,
              md: 3,
            }}
          >
            {field.valueType === "collection" ? (
              // Render Dropdown for collection
              <FormControl variant="outlined" size={"small"}>
                <InputLabel
                  id={`selected${field.attrName}`}
                  htmlFor="outlined-age-native-simple"
                >
                  {" "}
                  {t("SEARCH_BY")}{" "}
                  {field.attrDescription
                    ? field.attrDescription
                    : field.attrName}
                </InputLabel>
                <Select
                  labelId={`selected${field.attrName}`}
                  label={`Search by ${field.attrDescription ? field.attrDescription : field.attrName}`}
                  native
                  size={"small"}
                  variant={"outlined"}
                  onChange={(e) => handleChange(e, field.attrName)}
                  value={formData[field.attrName] || "-"}
                >
                  <option value={"-"} className={`${classes.optionDisabled}`}>
                    Select{" "}
                    {field.attrDescription
                      ? field.attrDescription
                      : field.attrName}
                  </option>
                  {field.options.map((option) => (
                    <option key={option.id} value={option.value}>
                      {option.value}
                    </option>
                  ))}
                </Select>
              </FormControl>
            ) : (
              // Render Input for other types
              //    size={'small'}
              //     variant={'outlined'}
              //     placeholder={t('SEARCH_BY_OFFERING_CODE')}
              //     value={this.state.productCode}
              //     name={"productCode"}
              //     onChange={(e) => { this.onChangeSearchFilter(e) }}
              //     divClass={classes.inputClass}
              //     onKeyDown={(e) => { this.onSearchKeyDown(e) }}

              <Input
                size={"small"}
                variant={"outlined"}
                placeholder={`${t("SEARCH_BY")} ${field.attrDescription ? field.attrDescription : field.attrName}`}
                // placeholder={`${t('SEARCH_BY')} ${
                //     (field.attrDescription || field.attrName).length > 20
                //         ? `${(field.attrDescription || field.attrName).substring(0, 17)}...`
                //         : field.attrDescription || field.attrName
                // }`}
                name={field.attrName}
                divClass={classes.inputClass}
                className={classes.inputPlaceholder}
                value={formData[field.attrName] || ""}
                onChange={(e) => handleChange(e, field.attrName)}
              />
            )}
          </Grid>
        ))}
    </>
  );
};

export default SearchComponent;
